import styled from 'styled-components';

import BackgroundLogo from "../../assets/images/back_logo.png";

const MyDiv = styled.div`
  .login-container {
    height: 100vh;
    width: 100%;
  }
  .login-flex-wrapper {
    height: 100%;
    display: flex;
    flex-direction: row;
  }
  .login-left {
    width: 50%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 110px 0 0 100px;
    min-height: 100vh;
    box-sizing: border-box;
  }
  .login-left::before {
    content: "";
    background-image: url(${BackgroundLogo});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 1;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1; 
  }
  .login-logo {
    width: 160px;
    margin-bottom: 40px;
    background-color: #ffffff;
    mix-blend-mode: multiply;
  }
.login-flex-wrapper {
  height: 100%;
  display: flex;
  flex-direction: row;
}
.login-left {
  width: 50%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 110px 0 0 100px; 
  position: relative;
  min-height: 100vh;
  box-sizing: border-box;
}
.login-logo {
  width: 160px;
  margin-bottom: 40px;
  background-color: #ffffff;
  mix-blend-mode: multiply;
}
.login-left-content {
  max-width: 400px;
}
.login-heading {
  white-space: pre-line;
  margin-bottom: 16px;
  line-height: 1.4;
}
.login-subheading {
  white-space: pre-line;
  line-height: 1.6;
}
.login-right {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
}
.login-card {
  background-color: #ffffff;
  padding: 32px;
  border-radius: 12px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}
.login-title {
  margin-bottom: 24px;
}
.form-group {
  margin-top: 20px;
}
.input {
  padding: 10px;
  border-radius: 6px;
}
.forgot-link {
  text-decoration: underline;
}
.login-button {
  width: 100%;
}

`;

export default MyDiv;
